<template>

    <div>

        <div class="card" v-if="candidato">
            <div class="card-body">

                <div class="row mb-2">
                    <div class="col-md-8 ">
                        <h6 class="card-subtitle text-muted">Candidato</h6>
                        <h5 class="card-title">{{candidato.colaborador.nmCompleto}}</h5>
                    </div>
                    <div class="col-md-4 ">
                        <h6 class="card-subtitle text-muted">Cargo</h6>
                        <h5 class="card-title">{{candidato.cargo.nmCargo}}</h5>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-4">
                        <h6 class="card-subtitle text-muted">Entrevista realizada em</h6>
                        <h5 class="card-title">{{entrevista.dtEntrevista}}</h5>
                    </div>
                    <div class="col-md-4">
                        <h6 class="card-subtitle text-muted">Nota Obtida</h6>
                        <h5 class="card-title">{{candidato.teste.nota}}% de ({{candidato.teste.avaliacao.notaAprovacao}}% para aprovação)</h5>
                    </div>
                    <div class="col-md-4">
                        <h6 class="card-subtitle text-muted">Situação</h6>
                        <h5 class="card-title">{{candidato.teste.situacaoTeste.nome}}</h5>
                    </div>
                </div>

            </div>
        </div>

        <br />

        <ul class="list-group">
            <li class="list-group-item" v-for="entrevistaConceito in entrevista.collectionEntrevistaConceito" v-bind:key="entrevistaConceito.conceitoId">
                <div class="row">
                    <div class="col-md-8">
                        {{entrevistaConceito.conceito.nome}}
                        <i class="fa fa-question-circle" v-b-tooltip.right :title="entrevistaConceito.conceito.descricao" v-if="entrevistaConceito.conceito.descricao"></i>
                    </div>
                    <div class="col-md-4">
                        <div class="btn-group btn-group-toggle float-right" v-b-tooltip.hover title="Nota do Conceito">
                            <label class="btn btn-sm border-success" v-bind:class="{ active: entrevistaConceito.avaliacao == 1, 'btn btn-sm btn-success': entrevistaConceito.avaliacao == 1 }">
                                <input disabled type="radio" v-model="entrevistaConceito.avaliacao" value="1"> 1
                            </label>
                            <label class="btn btn-sm border-success" v-bind:class="{ active: entrevistaConceito.avaliacao == 2, 'btn btn-sm btn-success': entrevistaConceito.avaliacao == 2 }">
                                <input disabled type="radio" v-model="entrevistaConceito.avaliacao" value="2"> 2
                            </label>
                            <label class="btn btn-sm border-success" v-bind:class="{ active: entrevistaConceito.avaliacao == 3, 'btn btn-sm btn-success': entrevistaConceito.avaliacao == 3 }">
                                <input disabled type="radio" v-model="entrevistaConceito.avaliacao" value="3"> 3
                            </label>
                            <label class="btn btn-sm border-success" v-bind:class="{ active: entrevistaConceito.avaliacao == 4, 'btn btn-sm btn-success': entrevistaConceito.avaliacao == 4 }">
                                <input type="radio" disabled v-model="entrevistaConceito.avaliacao" value="4"> 4
                            </label>
                        </div>
                    </div>
                </div>
            </li>
        </ul>

        <br />

        <div class="row" v-if="entrevista.observacoes != null">
            <div class="form-group col-md-12">
                <label>Observações</label>
                <textarea type="text"
                          disabled
                          class="form-control"
                          name="observacoes"
                          v-model="entrevista.observacoes"
                          placeholder="Insira informações complementares para finalizar esta entrevista" />
            </div>
        </div>

        <br />

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>

    </div>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "details-entrevista",
        mixins: [base],
        props: { candidatoId: Number, entrevistaId: Number },
        data: () => ({

            entrevista: {},
            candidato: null,

        }),

        methods: {

            onBack: function () {
                this.$emit('on-back')
            },

        },

        mounted() {

            new Api('entrevista').get({ entrevistaId: this.entrevistaId }).then(data => {
                this.entrevista = data.dataList[0];
            }, err => { this.defaultErrorResult(err); })

            new Api('candidato').get({ candidatoId: this.candidatoId }).then(data => {
                this.candidato = data.dataList[0];
            }, err => { this.defaultErrorResult(err); })

        }
    };
</script>
